import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=02170d12&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"
import style0 from "./Galeria.vue?vue&type=style&index=0&id=02170d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02170d12",
  null
  
)

export default component.exports